// extracted by mini-css-extract-plugin
module.exports = {"desktopOnly":"yqqQg","mobileOnly":"_3zOZz","signIn":"_23Vr5","signInContainer":"_2ZOcV","hasShadow":"_2AFBJ"};